export default "__VITE_ASSET__DaC68bHx__"